export const LoadingTable = () => {
    return(
        <div className='table-container loading-table animate'></div>
    );
}